import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, addLocaleData } from 'react-intl';
import fr from 'react-intl/locale-data/fr';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import es from 'react-intl/locale-data/es';
addLocaleData([...en, ...fr, ...de, ...es]); // react-intl v2 only
// imports below are from the services using them. Each service has an alias mapping intl-web to the respective intl-web-* repo i.e intl-web-templates, intl-web-search, etc.
import enJson from 'intl-web/compiled/en-US.json';
import frJson from 'intl-web/compiled/fr-FR.json';
import gbJson from 'intl-web/compiled/en-GB.json';
import deJson from 'intl-web/compiled/de-DE.json';
import esJson from 'intl-web/compiled/es-ES.json';


import frShared from '../intl-shared-component/compiled/fr-FR.json';
import enShared from '../intl-shared-component/compiled/en-US.json';
import gbShared from '../intl-shared-component/compiled/en-GB.json';
import deShared from '../intl-shared-component/compiled/de-DE.json';
import esShared from '../intl-shared-component/compiled/es-ES.json';

import get from 'lodash/get';

const loadTranslationData = (translationLocale) => {
  const lowercaseLocale = translationLocale.toLowerCase();
  switch (lowercaseLocale) {
  case 'fr-fr':
  case 'fr':
    return { ...frJson, ...frShared };
  case 'en-gb':
    return { ...gbJson, ...gbShared };
  case 'de-de':
    return { ...deJson, ...deShared };
  case 'es-es':
    return { ...esJson, ...esShared };
  default:
    return { ...enJson, ...enShared };
  }
};


export default class SharedIntlProviderHOC extends React.Component {
  static getEnvLocaleData() {
    try {
      if ('undefined' !== typeof document) {
        const trojanElement = document.getElementById('initial-data');
        if (trojanElement) {
          const envLocalMapString = trojanElement.getAttribute('data-locale-data');
          return JSON.parse(envLocalMapString)
        }
      }
    } catch (e) {
      return;
    }
    return {};
  }

  static getLocale () {
    let trojanElement;
    let userLocale = '';

    try {
      if ('undefined' !== typeof document) {
        trojanElement = document.getElementById('initial-data');
        if (trojanElement) {
          userLocale = trojanElement.getAttribute('data-user-locale');
        }
      }
    } catch (e) {
      return;
    }
    const envLocaleData = SharedIntlProviderHOC.getEnvLocaleData() || {};
    return envLocaleData[userLocale] && userLocale || 'en-US';
  }

  static getUrlPrefix() {
    const locale = SharedIntlProviderHOC.getLocale();
    const envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
    const urlPrefix = get(envLocaleData,`${locale}.url_prefix`,'');
    return urlPrefix;
  }

  static getTranslations() {
    const locale = SharedIntlProviderHOC.getLocale();
    const envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
    const translations = get(envLocaleData,`${locale}.translations`, 'en-US');
    return translations;
  }

  static getZendeskLocale() {
    const locale = SharedIntlProviderHOC.getLocale();
    const envLocaleData = SharedIntlProviderHOC.getEnvLocaleData();
    const zenDeskLocale = get(envLocaleData,`${locale}.zendesk_url_locale`, 'en-us');
    return zenDeskLocale;
  }

  getMessages() {
    const locale = this.props.locale || SharedIntlProviderHOC.getLocale();
    const envLocaleData = this.props.envLocaleData || SharedIntlProviderHOC.getEnvLocaleData();
    // iosLocale is passed as a prop from profile for iOS webview
    const translationLocale = get(envLocaleData,`${locale}.translations`, '') || this.props.iosLocale || '';
    return loadTranslationData(translationLocale);
  }

  constructor (props) {
    super(props);
    // This is to account for the components that use its own locale like locale of space or booking
    const locale = this.props.locale || SharedIntlProviderHOC.getLocale();

    this.state = {
      messages: this.getMessages(),
      locale
    };
  }

  render () {
    // iosLocale is passed as a prop from profile for iOS webview
    const locale = this.state.locale || this.props.iosLocale;

    return (
      <IntlProvider locale={locale || 'en'} messages={this.state.messages}>
        { this.props.children }
      </IntlProvider>
    );
  }
}

SharedIntlProviderHOC.propTypes = {
  locale: PropTypes.string,
  envLocaleData: PropTypes.object,
  children: PropTypes.object
};
